// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iView);

import storage from '@/utils/storage.js';
Vue.prototype.$storage=storage;

axios.interceptors.response.use(function(response){
  try {
    if(response.data.code===403||response.data.code==='403'){
      Vue.prototype.$Notice.error({
        title: '异常信息',
        desc: response.data.msg,
        duration: 0
      });
      router.push({path:'/login'});
    }
  }catch (e) {
  }
  // 请求成功处理回调
  return response;
}, function(error){
  console.log(error);
  Vue.prototype.$Notice.error({
    title: '服务器错误或网络异常',
    desc: '请刷新网页或重新登录后重试，如未解决请联系管理员。<br/>错误信息：'+error,
    duration: 0
  });
});


import qs from 'qs';
Vue.prototype.$qs=qs;
import axios from 'axios';
Vue.prototype.$axios=axios;

Vue.config.productionTip = false

// router.beforeEach((to, from, next) => {
//   if(to.path==='/login'||to.path==='/WebView'||to.path==='OpenApply'){
//     next();
//   }else{
//     let uuid = storage.getSession('uid');
//     if(uuid){
//       next();
//     }else{
//       router.push({path:'/login'});
//     }
//   }
// });

import store from '@/utils/store.js'; //全局状态管理

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js